// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chartUserTypeRender_chartHeight__t-1mA {\n    height: 700px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }", "",{"version":3,"sources":["webpack://./src/pages/chartUserType/chartUserTypeRender/chartUserTypeRender.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB","sourcesContent":[".chartHeight {\n    height: 700px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartHeight": "chartUserTypeRender_chartHeight__t-1mA"
};
export default ___CSS_LOADER_EXPORT___;
